import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductsRoutingModule } from './products-routing.module';
import { ProductsComponent } from './products.component';
import { CreateProductComponent } from './create-product/create-product.component';
import { ControlsModule } from 'src/app/shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditProductComponent } from './edit-product/edit-product.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReusableModule } from 'src/app/shared/reusable/reusable.module';
import {MatFormFieldModule} from '@angular/material/form-field'
import {MatSelectModule} from '@angular/material/select'

@NgModule({
  declarations: [ProductsComponent, CreateProductComponent, EditProductComponent],
  imports: [
    CommonModule,
    ProductsRoutingModule,
    ControlsModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    ReusableModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
})
export class ProductsModule {}
